import { render, staticRenderFns } from "./BodyPartsEditForm.vue?vue&type=template&id=c131b370&scoped=true&"
import script from "./BodyPartsEditForm.vue?vue&type=script&lang=ts&"
export * from "./BodyPartsEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./BodyPartsEditForm.vue?vue&type=style&index=0&id=c131b370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c131b370",
  null
  
)

export default component.exports